<template>
    <div class="tyn-root">
        <Header />
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">

                    <!-- Erro: não renderiza viewer -->
                    <div v-if="errorMsg" class="blocker">
                        <h3>Não foi possível abrir o artefato</h3>
                        <p class="motivo">{{ errorMsg }}</p>
                        <button class="btn" @click="tentarNovamente">Tentar novamente</button>
                    </div>

                    <div v-else class="viewer-layout">
                        <div class="pdf-wrapper">
                            <div ref="pdfviewer" class="pdf-host"></div>
                        </div>

                        <aside class="side-panel">
                            <!-- Header do Artefato -->
                            <div class="panel-header">
                                <div class="header-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                        <polyline points="14 2 14 8 20 8"></polyline>
                                    </svg>
                                </div>
                                <div class="header-content">
                                    <h3 class="titulo-artefato">
                                        {{ processoArtefato?.nmModeloArtefato || 'Artefato' }}
                                    </h3>
                                    <p class="sub">
                                        {{ processoArtefato?.dsNomeProcesso }}
                                    </p>
                                    <span v-if="processoArtefato?.cdProcesso" class="codigo-badge">
                                        #{{ processoArtefato.cdProcesso }}
                                    </span>
                                </div>
                            </div>

                            <!-- Status Card -->
                            <div class="info-card status-card">
                                <div class="card-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <polyline points="12 6 12 12 16 14"></polyline>
                                    </svg>
                                    Status Atual
                                </div>
                                <div class="status-badge" :class="statusCode === '5' ? 'status-aprovacao' : 'status-revisao'">
                                    {{ processoArtefato?.nmStatusAtual || '—' }}
                                </div>
                            </div>
                            <div class="info-card details-card assinantes-card" v-if="assinantesComCargo.length">
                                <div class="card-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                         viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="9" cy="7" r="4"></circle>
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                    </svg>
                                    Assinantes
                                </div>

                                <ul class="assinantes-list">
                                    <li v-for="a in assinantesComCargo"
                                        :key="a.idProcessoEnvolvido"
                                        class="assinante-item"
                                        :class="{ 'assinado': a.flAssinado }">

                                        <div class="assinante-header">
                                            <div class="assinante-avatar" :class="a.flAssinado ? 'avatar-success' : 'avatar-warning'">
                                                <svg v-if="a.flAssinado" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                                </svg>
                                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <polyline points="12 6 12 12 16 14"></polyline>
                                                </svg>
                                            </div>
                                            <div class="assinante-info">
                                                <div class="nome-wrapper">
                                                    <span class="nome">{{ a.nmPessoa }}</span>
                                                </div>
                                                <span class="cargo">{{ a.nmTipoEnvolvido }}</span>
                                            </div>
                                        </div>

                                        <!-- Botão de reenvio só para pendentes -->
                                        <button v-if="!a.flAssinado"
                                                class="btn-reenviar"
                                                :disabled="reenviandoEmail"
                                                @click="reenviarNotificacao(a)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <polyline points="23 4 23 10 17 10"></polyline>
                                                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                                            </svg>
                                            <span>Reenviar e-mail</span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <!-- Informações Detalhadas -->
                            <div class="info-card details-card">
                                <div class="card-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <line x1="12" y1="16" x2="12" y2="12"></line>
                                        <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                    </svg>
                                    Detalhes
                                </div>
                                <div class="info-grid">
                                    <div class="info-item" v-if="processoArtefato?.dsLoginResponsavel">
                                        <span class="label">Responsável</span>
                                        <span class="value">{{ processoArtefato.dsLoginResponsavel }}</span>
                                    </div>
                                    <div class="info-item" v-if="processoArtefato?.dtInclusaoStatus">
                                        <span class="label">Enviado para Assinatura em</span>
                                        <span class="value">{{ formatarData(processoArtefato.dtInclusaoStatus) }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Ações -->
                            <div class="acoes-section">

                            </div>
                        </aside>
                    </div>

                </div>
            </div>
        </div>
        <Modais />
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import { urlApi, avisoToast, avisoErro } from '@/config/global'
    import axios from 'axios'
    import {
        PdfViewer, Toolbar, Magnification, Navigation, Annotation, TextSelection, Print, FormFields, LinkAnnotation, BookmarkView, ThumbnailView
    } from '@syncfusion/ej2-pdfviewer'
    import { L10n, setCulture } from '@syncfusion/ej2-base'
    import ptBR from '@syncfusion/ej2-locale/src/pt-BR.json'

    L10n.load(ptBR)
    setCulture('pt-BR')

    PdfViewer.Inject(
        Toolbar, Magnification, Navigation, Annotation, TextSelection, Print,
        FormFields, LinkAnnotation, BookmarkView, ThumbnailView)

    export default {
        name: 'ProcessoAssinatura',
        components: { Header, Modais },
        data() {
            return {
                processoArtefato: null,
                viewer: null,
                loading: false,
                errorMsg: null,
                tiposEnvolvidos: [],
                assinantes: [],
                idProcesso: null,
                reenviandoEmail: false,
            }
        },
        computed: {
            statusCode() {
                const cd = this.processoArtefato?.cdStatusAtual
                if (cd) return String(cd)
                const fase = this.processoArtefato?.tpFaseAtual
                if (fase === 'Revisão') return '3'
                if (fase === 'Aprovação') return '5'
                return null
            },
            isRevisao() {
                return this.statusCode === '3'
            },
            isAprovacao() {
                return this.statusCode === '5'
            },
            assinantesComCargo() {
                const mapaCargos = this.tiposEnvolvidos.reduce((acc, t) => {
                    acc[t.idTipoEnvolvido] = t.nmTipoEnvolvido;
                    return acc;
                }, {});

                return this.assinantes.map(a => ({
                    ...a,
                    nmTipoEnvolvido: mapaCargos[a.idTipoEnvolvido] || '—'
                }));
            }
        },
        methods: {
            
            load() {
                this.getProcessoArtefato()
                this.getCargosAssinantes()
            },

            async getProcessoArtefato() {
                this.loading = true
                this.errorMsg = null
                try {
                    const id = this.$route.params.id
                    const { data } = await axios.get(
                        `${urlApi}/ProcessoArtefato/GetProcessoArtefatoRevisaoAprovacao`,
                        { params: { idProcessoArtefato: id } }
                    )

                    if (data?.success) {
                        const dto = Array.isArray(data.data) ? data.data[0] : data.data
                        if (!dto) {
                            this.setError('Artefato não encontrado.')
                            return
                        }
                        this.processoArtefato = dto

                        this.$nextTick(async () => {
                            if (!this.viewer && this.$refs.pdfviewer) this.mountPdfViewer();

                            if (this.viewer && dto.urlArquivoRevisado) {
                                try {
                                    const { data: base64 } = await axios.get(`${urlApi}/PdfViewer/FetchAsBase64`, {
                                        params: { url: dto.urlArquivoRevisado }
                                    });
                                    this.viewer.load(base64, null);
                                } catch (e) {
                                    this.setError('Não foi possível carregar o PDF do repositório.');
                                }
                            }
                        });
                        this.getProcessoAssinatura();
                    } else {
                        const msg = data?.msg || 'Erro ao carregar artefato.'
                        this.setError(msg)
                        avisoErro(msg)
                        avisoToast('Não foi possível abrir o artefato.', 'warning')
                    }
                } catch (err) {
                    const payload = err.response?.data
                    const msg =
                        (typeof payload === 'string' ? payload : payload?.msg) ||
                        err.message ||
                        'Erro desconhecido.'
                    this.setError(msg)
                    avisoErro(msg)
                    avisoToast('Erro ao carregar artefato!', 'warning')
                } finally {
                    this.loading = false
                }
            },

            getProcessoAssinatura() {
                let $this = this;
                const id = this.$route.params.id
                axios.get(`${urlApi}/ProcessoAssinatura/Get`, { params: { idProcessoArtefato: id } })
                    .then(res => {
                        if (res?.data?.success) {
                            const rows = res.data.data.rows || [];
                            if (rows.length > 0) {
                                const item = rows[0];
                                $this.idProcesso = item.processo.idProcesso;
                                $this.getProcessoAssinaturaEnvolvidos();
                            }
                        } else {
                            console.warn('Resposta sem sucesso');
                        }
                    })
                    .catch(err => {
                        console.error('Erro ao fazer requisição:', err);
                        avisoToast('Erro ao carregar processos!', 'warning');
                    });
            },

            getProcessoAssinaturaEnvolvidos() {
                let $this = this;
                axios.get(`${urlApi}/Pessoa/GetPessoasProcessoAssinatura`, { params: { idProcesso: $this.idProcesso } })
                    .then(res => {
                        if (res.data.success) {
                            const rows = res.data.data.result.rows || [];
                            console.log(rows);

                            $this.assinantes = rows.map(r => ({
                                idProcessoEnvolvido: r.idProcessoEnvolvido,
                                idTipoEnvolvido: r.idTipoEnvolvido,
                                flAssinado: !!r.flAssinado,
                                nmPessoa: r.nmPessoa,
                                dsEmail: r.dsEmail
                            }));
                        } else {
                            console.warn('Resposta sem sucesso');
                        }
                    })
                    .catch(err => {
                        console.error('Erro ao fazer requisição:', err);
                        avisoToast('Erro ao carregar processos!', 'warning');
                    });
            },

            getCargosAssinantes() {
                let $this = this;
                axios.get(`${urlApi}/TipoEnvolvido/Get`)
                    .then(res => {
                        if (res?.data?.success) {
                            const rows = res.data.data.rows || [];
                            $this.tiposEnvolvidos = rows.map(r => {
                                const t = r.tipoEnvolvido || r;
                                return {
                                    idTipoEnvolvido: t.idTipoEnvolvido,
                                    nmTipoEnvolvido: t.nmTipoEnvolvido,
                                    cdTipoEnvolvido: t.cdTipoEnvolvido
                                };
                            });
                        } else {
                            console.warn('Resposta sem sucesso');
                        }
                    })
                    .catch(err => {
                        console.error('Erro ao fazer requisição:', err);
                        avisoToast('Erro ao carregar processos!', 'warning');
                    });
            },

            async reenviarNotificacao(assinante) {
                if (!this.idProcesso) {
                    avisoToast('Processo não identificado para reenvio de e-mail.', 'warning')
                    return
                }

                if (!assinante.dsEmail) {
                    avisoToast('Assinante sem e-mail cadastrado.', 'warning')
                    return
                }

                this.reenviandoEmail = true
                try {
                    const payload = {
                        idProcesso: this.idProcesso,
                        dsEmail: assinante.dsEmail
                    }

                    const { data } = await axios.post(
                        `${urlApi}/ProcessoAssinatura/ReenviaNotificacao`,
                        payload
                    )

                    if (data?.success) {
                        avisoToast(`E-mail de assinatura reenviado para ${assinante.dsEmail}.`, 'success')
                    } else {
                        const msg = data?.msg || 'Não foi possível reenviar o e-mail.'
                        avisoErro(msg)
                    }
                } catch (err) {
                    const payload = err.response?.data
                    const msg =
                        (typeof payload === 'string' ? payload : payload?.msg) ||
                        err.message ||
                        'Erro ao reenviar e-mail.'

                    avisoErro(msg)
                    avisoToast('Falha ao reenviar e-mail.', 'warning')
                } finally {
                    this.reenviandoEmail = false
                }
            },

            mountPdfViewer() {
                if (this.viewer || !this.$refs.pdfviewer) return;

                const raw = this.$store?.state?.authToken || localStorage.getItem('authToken');
                const authHeader = raw?.startsWith('Bearer ') ? raw : (raw ? `Bearer ${raw}` : '');

                const openComments = () => {
                    const fn =
                        this.viewer.openCommentPanel ||
                        this.viewer.openCommentsPanel ||
                        this.viewer.openCommentsPane;
                    if (typeof fn === 'function') fn.call(this.viewer);
                };

                this.viewer = new PdfViewer({
                    locale: 'pt-BR',
                    serviceUrl: `${urlApi}/PdfViewer`,
                    ajaxRequestSettings: { withCredentials: false, headers: authHeader ? { Authorization: authHeader } : {} },

                    enableStampAnnotations: false,
                    enableHandwrittenSignature: false,
                    enableCommentPanel: true,

                    created: () => {
                        if (this.viewer.toolbarModule?.showAnnotationToolbar) {
                            this.viewer.toolbarModule.showAnnotationToolbar(true);
                        }
                        if (this.viewer.openAnnotationToolbar) {
                            this.viewer.openAnnotationToolbar('TextMarkup');
                        }
                    },

                    documentLoad: () => {
                        openComments();
                        setTimeout(openComments, 30);
                    },

                    pageRendered: () => {
                        if (!this._commentsOpened) {
                            this._commentsOpened = true;
                            openComments();
                        }
                    },

                    toolbarSettings: {
                        showTooltip: true,
                        toolbarItems: [
                            'PageNavigationTool', 'PanTool', 'SelectionTool',
                            'SearchOption', 'PrintOption', 'DownloadOption', 'UndoRedoTool',
                            'AnnotationEditTool', 'CommentTool'
                        ]
                    },
                    annotationToolbarSettings: {
                        annotationToolbarItems: [
                            'HighlightTool', 'UnderlineTool', 'StrikethroughTool', 'ShapeTool', 'CalibrateTool',
                            'FreeTextAnnotationTool', 'InkAnnotationTool',
                            'ColorEditTool', 'StrokeColorEditTool', 'ThicknessEditTool', 'OpacityEditTool',
                            'FontFamilyAnnotationTool', 'FontSizeAnnotationTool', 'FontStylesAnnotationTool',
                            'FontAlignAnnotationTool', 'FontColorAnnotationTool', 'AnnotationDeleteTool', 'CommentPanelTool'
                        ]
                    },
                    serverActionSettings: {
                        load: 'Load',
                        unload: 'Unload',
                        renderPages: 'RenderPdfPages',
                        renderThumbnail: 'RenderThumbnailImages',
                        bookmarks: 'Bookmarks',
                        download: 'Download',
                        print: 'PrintImages',
                        exportAnnotations: 'ExportAnnotations',
                        importAnnotations: 'ImportAnnotations',
                        exportFormFields: 'ExportFormFields',
                        importFormFields: 'ImportFormFields',
                        renderDocument: 'RenderPdfInformations',
                        textSearch: 'GetPdfDocumentTexts',
                        annotationComments: 'RenderAnnotationComments',
                    },
                    height: '100%',
                    width: '100%',
                });

                this.viewer.appendTo(this.$refs.pdfviewer);
            },

            setError(msg) {
                this.errorMsg = msg
                if (this.viewer) {
                    this.viewer.destroy()
                    this.viewer = null
                }
                this.processoArtefato = null
            },

            formatarData(iso) {
                try {
                    const d = new Date(iso)
                    return d.toLocaleString()
                } catch { return iso }
            },

            base64ToBlob(base64) {
                const b64 = base64.includes(',') ? base64.split(',')[1] : base64;
                const byteChars = atob(b64);
                const byteNumbers = new Array(byteChars.length);
                for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i);
                const byteArray = new Uint8Array(byteNumbers);
                return new Blob([byteArray], { type: 'application/pdf' });
            },

            async getAnnotatedPdfBlobViaServer() {
                if (!this.viewer) throw new Error('Viewer não inicializado.');

                const documentId =
                    this.viewer?.pdfViewerBase?.documentId ||
                    this.viewer?.viewerBase?.documentId;

                if (!documentId) {
                    throw new Error('documentId do viewer não encontrado (o documento precisa estar carregado).');
                }

                const raw = this.$store?.state?.authToken || localStorage.getItem('authToken');
                const authHeader = raw?.startsWith('Bearer ') ? raw : (raw ? `Bearer ${raw}` : '');

                const { data: base64 } = await axios.post(
                    `${urlApi}/PdfViewer/Download`,
                    { documentId, hashId: documentId },
                    { headers: authHeader ? { Authorization: authHeader } : undefined }
                );

                if (!base64 || typeof base64 !== 'string') {
                    throw new Error('Servidor não retornou base64 do PDF anotado.');
                }

                return this.base64ToBlob(base64);
            },

            async _isValidPdfBlob(blob) {
                try {
                    if (!blob || !blob.size) return false;
                    const header = new Uint8Array(await blob.slice(0, 5).arrayBuffer());
                    return header[0] === 0x25 && header[1] === 0x50 && header[2] === 0x44 && header[3] === 0x46 && header[4] === 0x2D;
                } catch {
                    return false;
                }
            },

            _base64ToBlobPdf(base64) {
                const b64 = base64.includes(',') ? base64.split(',')[1] : base64;
                const byteChars = atob(b64);
                const bytes = new Uint8Array(byteChars.length);
                for (let i = 0; i < byteChars.length; i++) bytes[i] = byteChars.charCodeAt(i);
                return new Blob([bytes], { type: 'application/pdf' });
            },

            async _getAnnotatedPdfBlobViaServer() {
                if (!this.viewer) throw new Error('Viewer não inicializado.');

                const documentId =
                    this.viewer?.pdfViewerBase?.documentId ||
                    this.viewer?.viewerBase?.documentId;

                if (!documentId) throw new Error('documentId não encontrado.');

                const raw = this.$store?.state?.authToken || localStorage.getItem('authToken');
                const authHeader = raw?.startsWith('Bearer ') ? raw : (raw ? `Bearer ${raw}` : '');

                const { data } = await axios.post(
                    `${urlApi}/PdfViewer/Download`,
                    { documentId, hashId: documentId },
                    { headers: authHeader ? { Authorization: authHeader } : undefined }
                );

                if (!data || typeof data !== 'string') {
                    throw new Error('Servidor não retornou base64 do PDF.');
                }
                return this._base64ToBlobPdf(data);
            },

            tentarNovamente() {
                this.getProcessoArtefato()
            },
        },

        mounted() {
            this.load()
        },

        beforeDestroy() {
            if (this.viewer) {
                this.viewer.destroy()
                this.viewer = null
            }
        }
    }
</script>

<style scoped>
.viewer-layout {
display: flex;
gap: 1px;
height: calc(100vh - var(--appbar-height));
}

.viewer-layout > * {
    min-width: 0;
    box-sizing: border-box;
}

.pdf-wrapper {
flex: 3 1 0;
}

.side-panel {
flex: 1 1 0;
max-width: 380px;
min-width: 320px;
padding: 24px 20px;
display: flex;
flex-direction: column;
gap: 20px;
overflow-y: auto;
overflow-x: hidden;
background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
border-left: 1px solid rgba(0, 0, 0, 0.08);
}

.pdf-host {
height: 100%;
width: 100%;
overflow: hidden;
}

/* Header do Artefato */
.panel-header {
background: linear-gradient(135deg, #235FE8 0%, #00d084 100%);
border-radius: 16px;
padding: 20px;
color: white;
box-shadow: 0 8px 24px rgba(35, 95, 232, 0.25);
display: flex;
gap: 16px;
align-items: flex-start;
animation: slideInRight 0.4s ease-out;
}

.header-icon {
background: rgba(255, 255, 255, 0.2);
border-radius: 12px;
padding: 12px;
display: flex;
align-items: center;
justify-content: center;
backdrop-filter: blur(10px);
flex-shrink: 0;
}

.header-icon svg {
    width: 24px;
    height: 24px;
    color: white;
}

.header-content {
flex: 1;
min-width: 0;
}

.titulo-artefato {
margin: 0 0 8px 0;
font-size: 1.25rem;
font-weight: 700;
line-height: 1.3;
color: white;
text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.sub {
margin: 0 0 10px 0;
font-size: 0.9rem;
opacity: 0.95;
color: rgba(255, 255, 255, 0.95);
line-height: 1.4;
}

.codigo-badge {
display: inline-block;
background: rgba(255, 255, 255, 0.25);
padding: 4px 12px;
border-radius: 20px;
font-size: 0.8rem;
font-weight: 600;
backdrop-filter: blur(10px);
border: 1px solid rgba(255, 255, 255, 0.3);
}

/* Cards de Informação */
.info-card {
background: white;
border-radius: 14px;
padding: 18px;
box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
border: 1px solid rgba(0, 0, 0, 0.05);
transition: all 0.3s ease;
animation: slideInRight 0.4s ease-out;
animation-fill-mode: both;
}

.info-card:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
}

.status-card {
animation-delay: 0.1s;
}

.details-card {
animation-delay: 0.2s;
}

.assinantes-card {
animation-delay: 0.15s;
}

.card-title {
display: flex;
align-items: center;
gap: 8px;
font-size: 0.85rem;
font-weight: 600;
color: #6c757d;
text-transform: uppercase;
letter-spacing: 0.5px;
margin-bottom: 14px;
}

.card-title svg {
    opacity: 0.7;
}

/* Status Badge */
.status-badge {
    display: inline-block;
    padding: 10px 18px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 0.95rem;
    text-align: center;
    width: 100%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    background: linear-gradient(135deg, #a8e6cf 0%, #56ccf2 100%);
    color: #155724;
}

.status-revisao {
background: linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%);
color: #856404;
}

.status-aprovacao {
background: linear-gradient(135deg, #a8e6cf 0%, #56ccf2 100%);
color: #155724;
}

/* Grid de Informações */
.info-grid {
display: grid;
gap: 14px;
}

.info-item {
display: flex;
flex-direction: column;
gap: 4px;
padding: 12px;
background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
border-radius: 10px;
border-left: 3px solid #235FE8;
transition: all 0.3s ease;
}

.info-item:hover {
    border-left-color: #00d084;
    transform: translateX(2px);
}

.info-item .label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.info-item .value {
    font-size: 0.95rem;
    font-weight: 600;
    color: #2d3748;
    line-height: 1.4;
}

/* Lista de Assinantes */
.assinantes-list {
list-style: none;
padding: 0;
margin: 0;
display: flex;
flex-direction: column;
gap: 12px;
}

.assinante-item {
background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
border: 1px solid rgba(0, 0, 0, 0.08);
border-radius: 12px;
padding: 14px;
transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
position: relative;
overflow: hidden;
}

.assinante-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    transition: all 0.3s ease;
}

.assinante-item.assinado::before {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.assinante-item:hover {
    transform: translateX(4px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    border-color: rgba(35, 95, 232, 0.2);
}

.assinante-header {
display: flex;
align-items: center;
gap: 12px;
margin-bottom: 10px;
}

.assinante-avatar {
width: 44px;
height: 44px;
border-radius: 12px;
display: flex;
align-items: center;
justify-content: center;
flex-shrink: 0;
transition: all 0.3s ease;
position: relative;
overflow: hidden;
}

.assinante-avatar::before {
    content: '';
    position: absolute;
    inset: 0;
    background: inherit;
    opacity: 0.1;
    transition: opacity 0.3s ease;
}

.assinante-item:hover .assinante-avatar::before {
    opacity: 0.2;
}

.assinante-avatar svg {
    position: relative;
    z-index: 1;
}

.avatar-success {
background: linear-gradient(135deg, #a8e6cf 0%, #56ccf2 100%);
color: #059669;
box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
}

.avatar-warning {
background: linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%);
color: #d97706;
box-shadow: 0 4px 12px rgba(245, 158, 11, 0.2);
}

.assinante-info {
flex: 1;
min-width: 0;
display: flex;
flex-direction: column;
gap: 4px;
}

.nome-wrapper {
display: flex;
align-items: center;
gap: 8px;
flex-wrap: wrap;
}

.assinante-item .nome {
font-size: 0.95rem;
font-weight: 600;
color: #2d3748;
line-height: 1.3;
}

.assinante-item .cargo {
font-size: 0.8rem;
color: #6c757d;
font-weight: 500;
display: flex;
align-items: center;
gap: 4px;
}

.assinante-item .cargo::before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: currentColor;
    opacity: 0.5;
}

.badge-success {
background: linear-gradient(135deg, #10b981 0%, #059669 100%);
color: white;
box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.badge-warning {
background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
color: white;
box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
}

/* Botão de Reenviar E-mail */
.btn-reenviar {
display: flex;
align-items: center;
justify-content: center;
gap: 6px;
padding: 8px 14px;
background: linear-gradient(135deg, #235FE8 0%, #00d084 100%);
color: white;
border: none;
border-radius: 8px;
font-size: 0.8rem;
font-weight: 600;
cursor: pointer;
transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
box-shadow: 0 2px 8px rgba(35, 95, 232, 0.25);
position: relative;
overflow: hidden;
width: 100%;
}

.btn-reenviar::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, transparent 70%);
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.5s ease;
}

.btn-reenviar:hover::before {
    transform: translate(-50%, -50%) scale(1);
}

.btn-reenviar:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(35, 95, 232, 0.4);
    background: linear-gradient(135deg, #1e50c9 0%, #00b872 100%);
}

.btn-reenviar:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(35, 95, 232, 0.3);
}

.btn-reenviar:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: 0 2px 8px rgba(35, 95, 232, 0.15);
}

.btn-reenviar svg {
    flex-shrink: 0;
    position: relative;
    z-index: 1;
    animation: rotate-icon 2s ease-in-out infinite;
}

.btn-reenviar:disabled svg {
    animation: spin 1s linear infinite;
}

.btn-reenviar span {
    position: relative;
    z-index: 1;
}

@keyframes spin {
from {
    transform: rotate(0deg);
}
to {
    transform: rotate(360deg);
}
}

@keyframes rotate-icon {
0%, 100% {
    transform: rotate(0deg);
}
50% {
    transform: rotate(360deg);
}
}

/* Seção de Ações */
.acoes-section {
margin-top: auto;
display: flex;
flex-direction: column;
gap: 12px;
animation: slideInRight 0.4s ease-out;
animation-delay: 0.3s;
animation-fill-mode: both;
}

.acoes-title {
font-size: 0.85rem;
font-weight: 700;
color: #495057;
text-transform: uppercase;
letter-spacing: 0.5px;
margin-bottom: 4px;
}

/* Botões de Ação */
.btn-action {
display: flex;
align-items: center;
justify-content: center;
gap: 10px;
padding: 14px 20px;
border: none;
border-radius: 12px;
font-size: 0.95rem;
font-weight: 600;
cursor: pointer;
transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
position: relative;
overflow: hidden;
color: white;
}

.btn-action::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 220%;
    height: 220%;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.6s ease;
    pointer-events: none;
}

.btn-action:hover::before {
    transform: translate(-50%, -50%) scale(1);
}

.btn-action:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
}

.btn-action:not(:disabled):hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.btn-action:not(:disabled):active {
    transform: translateY(0);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-action svg {
    flex-shrink: 0;
    position: relative;
    z-index: 1;
}

.btn-action span {
    flex: 1;
    text-align: center;
    position: relative;
    z-index: 1;
}

.btn-primary {
background: linear-gradient(135deg, #235FE8 0%, #00d084 100%);
box-shadow: 0 4px 12px rgba(35, 95, 232, 0.3);
}

.btn-primary:not(:disabled):hover {
    background: linear-gradient(135deg, #1e50c9 0%, #00b872 100%);
    box-shadow: 0 8px 24px rgba(35, 95, 232, 0.4);
}

.btn-primary:not(:disabled):active {
    background: linear-gradient(135deg, #1a47b5 0%, #009f65 100%);
}

.btn-success {
background: linear-gradient(135deg, #10b981 0%, #059669 100%);
box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.btn-success:not(:disabled):hover {
    background: linear-gradient(135deg, #0ea374 0%, #047857 100%);
    box-shadow: 0 8px 24px rgba(16, 185, 129, 0.4);
}

.btn-success:not(:disabled):active {
    background: linear-gradient(135deg, #0c8d63 0%, #036547 100%);
}

.btn-danger {
background: linear-gradient(135deg, #f43f5e 0%, #e11d48 100%);
box-shadow: 0 4px 12px rgba(244, 63, 94, 0.3);
}

.btn-danger:not(:disabled):hover {
    background: linear-gradient(135deg, #e11d48 0%, #be123c 100%);
    box-shadow: 0 8px 24px rgba(244, 63, 94, 0.4);
}

.btn-danger:not(:disabled):active {
    background: linear-gradient(135deg, #be123c 0%, #9f1239 100%);
}

.btn-warning {
background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

.btn-warning:not(:disabled):hover {
    background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
    box-shadow: 0 8px 24px rgba(245, 158, 11, 0.4);
}

.btn-warning:not(:disabled):active {
    background: linear-gradient(135deg, #b45309 0%, #92400e 100%);
}

/* Animações */
@keyframes slideInRight {
from {
    opacity: 0;
    transform: translateX(20px);
}

to {
    opacity: 1;
    transform: translateX(0);
}
}

/* Scrollbar customizada */
.side-panel::-webkit-scrollbar {
width: 6px;
}

.side-panel::-webkit-scrollbar-track {
background: rgba(0, 0, 0, 0.05);
border-radius: 10px;
}

.side-panel::-webkit-scrollbar-thumb {
background: linear-gradient(135deg, #235FE8 0%, #00d084 100%);
border-radius: 10px;
}

.side-panel::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #1e50c9 0%, #00b872 100%);
}

.blocker {
height: calc(100vh - var(--appbar-height));
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
text-align: center;
padding: 24px;
gap: 12px;
}

.blocker .motivo {
    max-width: 720px;
    opacity: .85;
    font-size: 0.95rem;
}

    .blocker .btn {
        padding: 10px 16px;
        border-radius: 10px;
        border: none;
        cursor: pointer;
    }

    /* ========== DARK THEME - SIDE PANEL ONLY ========== */
    [data-bs-theme="dark"] .side-panel {
        background: linear-gradient(135deg, #1a1f2e 0%, #252b3d 100%);
        border-left: 1px solid rgba(255, 255, 255, 0.1);
    }

    [data-bs-theme="dark"] .panel-header {
        background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
        box-shadow: 0 8px 24px rgba(96, 165, 250, 0.3);
    }

    [data-bs-theme="dark"] .header-icon {
        background: rgba(255, 255, 255, 0.25);
    }

    [data-bs-theme="dark"] .titulo-artefato,
    [data-bs-theme="dark"] .sub,
    [data-bs-theme="dark"] .codigo-badge {
        color: white;
    }

    [data-bs-theme="dark"] .codigo-badge {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.25);
    }

    [data-bs-theme="dark"] .info-card {
        background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
        border-color: rgba(255, 255, 255, 0.1);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
    }

    [data-bs-theme="dark"] .info-card:hover {
        box-shadow: 0 8px 24px rgba(96, 165, 250, 0.2);
        border-color: rgba(96, 165, 250, 0.3);
    }

    [data-bs-theme="dark"] .card-title {
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .status-badge {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
        background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
        color: #1f2937;
        font-weight: 700;
    }

    [data-bs-theme="dark"] .info-item {
        background: linear-gradient(135deg, #2d3548 0%, #353d52 100%);
        border-left-color: #60a5fa;
    }

    [data-bs-theme="dark"] .info-item:hover {
        border-left-color: #34d399;
        background: linear-gradient(135deg, #353d52 0%, #3d4558 100%);
    }

    [data-bs-theme="dark"] .info-item .label {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .info-item .value {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .assinante-item {
        background: linear-gradient(135deg, #2d3548 0%, #353d52 100%);
        border-color: rgba(255, 255, 255, 0.1);
    }

    [data-bs-theme="dark"] .assinante-item::before {
        background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
    }

    [data-bs-theme="dark"] .assinante-item.assinado::before {
        background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
    }

    [data-bs-theme="dark"] .assinante-item:hover {
        border-color: rgba(96, 165, 250, 0.3);
        background: linear-gradient(135deg, #353d52 0%, #3d4558 100%);
    }

    [data-bs-theme="dark"] .assinante-item .nome {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .assinante-item .cargo {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .avatar-success {
        background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
        color: #1f2937;
    }

    [data-bs-theme="dark"] .avatar-warning {
        background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
        color: #1f2937;
    }

    [data-bs-theme="dark"] .btn-reenviar {
        background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
        box-shadow: 0 4px 12px rgba(96, 165, 250, 0.4);
    }

    [data-bs-theme="dark"] .btn-reenviar:hover {
        background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
        box-shadow: 0 8px 24px rgba(96, 165, 250, 0.5);
    }

    [data-bs-theme="dark"] .acoes-title {
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .btn-action {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
    }

    [data-bs-theme="dark"] .btn-action:not(:disabled):hover {
        box-shadow: 0 8px 24px rgba(96, 165, 250, 0.3);
    }

    [data-bs-theme="dark"] .btn-primary {
        background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
        box-shadow: 0 4px 12px rgba(96, 165, 250, 0.4);
    }

    [data-bs-theme="dark"] .btn-primary:not(:disabled):hover {
        background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
        box-shadow: 0 8px 24px rgba(96, 165, 250, 0.5);
    }

    [data-bs-theme="dark"] .btn-primary:not(:disabled):active {
        background: linear-gradient(135deg, #2563eb 0%, #059669 100%);
    }

    [data-bs-theme="dark"] .btn-success {
        background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
        box-shadow: 0 4px 12px rgba(52, 211, 153, 0.4);
    }

    [data-bs-theme="dark"] .btn-success:not(:disabled):hover {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        box-shadow: 0 8px 24px rgba(52, 211, 153, 0.5);
    }

    [data-bs-theme="dark"] .btn-success:not(:disabled):active {
        background: linear-gradient(135deg, #059669 0%, #047857 100%);
    }

    [data-bs-theme="dark"] .btn-danger {
        background: linear-gradient(135deg, #f87171 0%, #ef4444 100%);
        box-shadow: 0 4px 12px rgba(248, 113, 113, 0.4);
    }

    [data-bs-theme="dark"] .btn-danger:not(:disabled):hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        box-shadow: 0 8px 24px rgba(248, 113, 113, 0.5);
    }

    [data-bs-theme="dark"] .btn-danger:not(:disabled):active {
        background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
    }

    [data-bs-theme="dark"] .btn-warning {
        background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
        box-shadow: 0 4px 12px rgba(251, 191, 36, 0.4);
    }

    [data-bs-theme="dark"] .btn-warning:not(:disabled):hover {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        box-shadow: 0 8px 24px rgba(251, 191, 36, 0.5);
    }

    [data-bs-theme="dark"] .btn-warning:not(:disabled):active {
        background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
    }

    [data-bs-theme="dark"] .side-panel::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
    }

    [data-bs-theme="dark"] .side-panel::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
    }

    [data-bs-theme="dark"] .side-panel::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
    }

    [data-bs-theme="dark"] .blocker {
        background: linear-gradient(135deg, #1a1f2e 0%, #252b3d 100%);
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .blocker h3 {
        color: #ffffff;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }

    [data-bs-theme="dark"] .blocker .motivo {
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .blocker .btn {
        background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
        color: white;
        box-shadow: 0 4px 12px rgba(96, 165, 250, 0.3);
        transition: all 0.3s ease;
    }

    [data-bs-theme="dark"] .blocker .btn:hover {
        background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
        box-shadow: 0 8px 24px rgba(96, 165, 250, 0.4);
        transform: translateY(-2px);
    }
</style>